import { IResourceComponentsProps } from "@refinedev/core";
import { AntdShowInferencer } from "@refinedev/inferencer/antd";
import Cw8Show from "components/cw8/Cw8Show";

export const FragmentObjectsShow: React.FC<IResourceComponentsProps> = () => {
  // return <AntdShowInferencer />;

  const resourceName :string = 'fragmentObject';
  return (
    <Cw8Show
      resourceName = {resourceName}
    ></Cw8Show>
  );     
};
